import { useEffect, useState } from "react";
import { PRESENCE_TICK_MS } from "../components/utils";

/**
 * Clock that ticks so relative presence labels stay current.
 *
 * @param {number} [intervalMs]
 * @returns {Date}
 */
export function useNow(intervalMs = PRESENCE_TICK_MS) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
